import { SuperbetRouteConfig } from '@superbet-group/web.types';
import { Route } from 'vue-router';

import AccountLockedRecoveryPage from '@accountFederation/modules/accountRecovery/pages/AccountLockedRecoveryPage.vue';
import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import {
    chainGuards,
    defaultLayout,
    guestsOnly,
    sendLanderAnalytics,
} from '@app/router/utils';
import { AnalyticsScreenNames } from '@app/utils/analyticsScreenNames';
import ActivateAccountPage from '@accountFederation/pages/ActivateAccountPage.vue';
import ContinueRegistrationPage from '@accountFederation/pages/ContinueRegistrationPage.vue';
import PasswordRecoveryPage from '@accountFederation/pages/PasswordRecoveryPage.vue';
import ForgotPasswordContainer from '@accountFederation/modals/resetPassword/ForgotPasswordContainer.vue';
import { registerPage } from '@pages/RegisterPage';
import ResendActivationEmailPage from '@accountFederation/pages/ResendActivationEmailPage.vue';

export const registerRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.Account.PasswordRecovery,
        name: RouteName.Account.PasswordRecovery,
        components: {
            ...defaultLayout,
            content: PasswordRecoveryPage,
        },
        meta: {
            title: Title.Account.PasswordRecovery,
            superAnalytics: {
                pageName: AnalyticsScreenNames.passwordRecovery,
            },
        },
        beforeEnter: chainGuards(
            [
                guestsOnly(),
                (to: Route, from: Route, next: AnyFunction) => {
                    if (!to.query.passwordToken) {
                        next({
                            name: RouteName.App.Home,
                            replace: true,
                        });
                    } else {
                        next();
                    }
                },
            ],
        ),
    },
    {
        path: Link.Account.Recovery,
        name: RouteName.Account.Recovery,
        components: {
            ...defaultLayout,
            content: AccountLockedRecoveryPage,
        },
        meta: {
            title: Title.Account.Recovery,
            superAnalytics: {
                pageName: AnalyticsScreenNames.accountRecovery,
            },
        },
        beforeEnter: chainGuards(
            [
                guestsOnly(),
                (to: Route, from: Route, next: AnyFunction) => {
                    if (!to.query.passwordToken) {
                        next({
                            name: RouteName.App.Home,
                            replace: true,
                        });
                    } else {
                        next();
                    }
                },
            ],
        ),
    },
    // This acts as a register wildcard (country agnostic) route so external platforms (e.g. native apps) dont need to define per country route paths
    {
        path: '/register-external-app',
        redirect: { name: RouteName.Account.Register },
    },
    {
        path: Link.Account.Register,
        name: RouteName.Account.Register,
        components: {
            ...defaultLayout,
            ...registerPage,
        },
        meta: {
            title: Title.Account.Register,
            layoutClass: 'register-page-layout',
            superAnalytics: {
                pageName: AnalyticsScreenNames.registration,
            },
            mobileHeaderConfig: {
                isTopLevelRoute: false,
                isHome: true,
                isContracted: true,
            },
        },
        beforeEnter: chainGuards([
            sendLanderAnalytics,
            guestsOnly(),
        ]),
    },
    {
        path: Link.Account.ForgotPassword,
        name: RouteName.Account.ForgotPassword,
        components: {
            ...defaultLayout,
            content: ForgotPasswordContainer,
        },
        meta: {
            title: Title.Account.ForgotPassword,
            superAnalytics: {
                pageName: AnalyticsScreenNames.forgotPassword,
            },
        },
        beforeEnter: guestsOnly(),
    },
    {
        path: Link.Account.ResendActivationEmail,
        name: RouteName.Account.ResendActivationEmail,
        components: {
            ...defaultLayout,
            content: ResendActivationEmailPage,
        },
        meta: {
            title: Title.Account.ResendActivationEmail,
            superAnalytics: {
                pageName: AnalyticsScreenNames.resendActivationEmail,
            },
        },
        beforeEnter: guestsOnly(),
    },
    {

        path: Link.Account.Activate,
        name: RouteName.Account.Activate,
        components: {
            ...defaultLayout,
            content: ActivateAccountPage,
        },
        meta: {
            title: Title.Account.Activate,
            superAnalytics: {
                pageName: AnalyticsScreenNames.activateAccount,
            },
        },
        beforeEnter: chainGuards(
            [
                guestsOnly(),
                (to: Route, from: Route, next: AnyFunction) => {
                    if (!to.query.activationCode) {
                        next({
                            name: RouteName.App.Home,
                            replace: true,
                        });
                    } else {
                        next();
                    }
                },
            ],
        ),
    },
    {
        path: Link.Account.ContinueRegistration,
        name: RouteName.Account.ContinueRegistration,
        components: {
            ...defaultLayout,
            content: ContinueRegistrationPage,
        },
        meta: {
            title: Title.Account.ContinueRegistration,
            layoutClass: 'register-page-layout',
            superAnalytics: {
                pageName: AnalyticsScreenNames.continueRegistration,
            },
            mobileHeaderConfig: {
                isTopLevelRoute: false,
                isHome: true,
                isContracted: true,
            },
        },
        beforeEnter: chainGuards(
            [
                guestsOnly(),
                (to: Route, from: Route, next: AnyFunction) => {
                    if (!to.query.code) {
                        next({
                            name: RouteName.Account.Register,
                            replace: true,
                        });
                    } else {
                        next();
                    }
                },
            ],
        ),
    },
];
